var _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFocusCoaching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40.4997,
    cy: 40.0019,
    r: 30.8571,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 40.4999,
    cy: 40.0021,
    r: 19.4286,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9556 54.0076C41.3382 55.8995 38.6618 55.8995 38.0444 54.0076L35.1659 45.1874C34.9525 44.5334 34.4263 44.0294 33.7637 43.8444L27.0935 41.9813C25.0886 41.4213 25.0886 38.5787 27.0935 38.0187L33.7637 36.1556C34.4263 35.9706 34.9525 35.4666 35.1659 34.8126L38.0444 25.9924C38.6618 24.1005 41.3382 24.1005 41.9556 25.9924L44.8341 34.8126C45.0475 35.4666 45.5737 35.9706 46.2363 36.1556L52.9065 38.0187C54.9114 38.5787 54.9114 41.4213 52.9065 41.9813L46.2363 43.8444C45.5737 44.0294 45.0475 44.5334 44.8341 45.1874L41.9556 54.0076Z",
    fill: "#FFDC83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8574 26.8197C59.4892 27.8147 58.0819 27.8147 57.7137 26.8197L56.1899 22.7015C56.0741 22.3887 55.8275 22.1421 55.5147 22.0263L51.3964 20.5024C50.4014 20.1342 50.4014 18.7269 51.3964 18.3588L55.5147 16.8349C55.8275 16.7191 56.0741 16.4725 56.1899 16.1597L57.7137 12.0415C58.0819 11.0465 59.4892 11.0465 59.8574 12.0415L61.3813 16.1597C61.497 16.4725 61.7437 16.7191 62.0565 16.8349L66.1747 18.3588C67.1697 18.7269 67.1697 20.1342 66.1747 20.5024L62.0565 22.0263C61.7437 22.1421 61.497 22.3887 61.3813 22.7015L59.8574 26.8197Z",
    fill: "#FFEFC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2861 70.2482C22.9179 71.2432 21.5106 71.2432 21.1425 70.2482L19.6186 66.13C19.5028 65.8172 19.2562 65.5705 18.9434 65.4548L14.8252 63.9309C13.8302 63.5627 13.8302 62.1554 14.8252 61.7872L18.9434 60.2634C19.2562 60.1476 19.5028 59.901 19.6186 59.5881L21.1425 55.4699C21.5106 54.4749 22.9179 54.4749 23.2861 55.4699L24.81 59.5881C24.9257 59.901 25.1724 60.1476 25.4852 60.2634L29.6034 61.7872C30.5984 62.1554 30.5984 63.5627 29.6034 63.9309L25.4852 65.4548C25.1724 65.5705 24.9257 65.8172 24.81 66.13L23.2861 70.2482Z",
    fill: "#FFEFC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusCoaching);
export default __webpack_public_path__ + "static/media/focus_coaching.fb1e92cca3ee3961ae950a6c6844df37.svg";
export { ForwardRef as ReactComponent };